import React from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import logo from '~images/logo-paketti-text.svg';
import { closePrintView, getPositionY, getTask, isPrintView } from './ducks';

const PrintOrder = ({ task, closePrintView, positionY }) => (
  <Wrapper>
    <PrintButtons>
      <button
        onClick={() => {
          closePrintView();
          setTimeout(() => {
            window.scrollTo(0, positionY);
          }, 10);
        }}
      >
        Takaisin
      </button>
      <button onClick={() => window.print()}>Tulosta</button>
    </PrintButtons>
    <Logo src={logo} />
    <Title>
      Tämä asia
      <br />
      on jo hoidossa!
    </Title>
    <Subtitle>
      Voit seurata työn edistymistä osoitteessa
      <br />
      <Strong>paketti.pshp.fi</Strong>
    </Subtitle>
    <Line />
    <Row>
      <Left>Tilauksen aihe:</Left>
      <Right>{task.items[0].categoryName}</Right>
    </Row>
    <Row>
      <Left>Tilausnumero:</Left>
      <Right>{task.id}</Right>
    </Row>
    <Row>
      <Left>Tilauksen tekijä:</Left>
      <Right>{task.initiator.name}</Right>
    </Row>
    <Row>
      <Left>Tilausaika:</Left>
      <Right>{moment(task.initiationTime).format('DD.MM.YYYY hh:mm')}</Right>
    </Row>
  </Wrapper>
);

const Wrapper = styled.div`
  background-color: #fff;
  font-size: 60%;
  width: 210mm;
  min-height: 297mm;
  margin-left: auto;
  margin-right: auto;
  padding: 20mm;
  @media print {
    padding: 0;
    font-size: 90%;
    width: auto;
  }
`;

const Logo = styled.img`
  width: auto;
  height: 50px;
  margin-bottom: 150px;
`;

const Title = styled.h1`
  color: #133679 !important;
  -webkit-print-color-adjust: exact;
  font-size: 8em;
  text-align: center;
  margin-bottom: 120px;
  font-weight: 700;
`;

const PrintButtons = styled.div`
  @media print {
    display: none;
  }
  position: fixed;
  top: 5px;
  left: 5px;
  > button {
    outline: none;
    color: #fff;
    background-color: #163979;
    padding: 10px 20px;
    border: 0;
    font-size: 20px;
    margin-right: 5px;
  }
  > button:nth-child(1) {
    background-color: #b3b3b3;
  }
  > button:nth-child(2) {
    background-color: #3d965a;
  }
`;

const Subtitle = styled.h3`
  color: #133679 !important;
  -webkit-print-color-adjust: exact;
  text-align: center;
  font-size: 3.5em;
  margin-bottom: 180px;
  line-height: 1.3;
`;

const Strong = styled.strong`
  color: #133679 !important;
  -webkit-print-color-adjust: exact;
`;

const Line = styled.hr`
  border-top: 1px solid #133679 !important;
  -webkit-print-color-adjust: exact;
`;

const Row = styled.div`
  display: flex;
  height: 60px;
  align-items: center;
`;

const Left = styled.div`
  width: 35%;
  color: #133679 !important;
  -webkit-print-color-adjust: exact;
  font-size: 2.2em;
  font-weight: 700;
`;

const Right = styled.div`
  font-size: 2.2em;
`;

const mapStateToProps = state => ({
  isPrintView: isPrintView(state),
  task: getTask(state),
  positionY: getPositionY(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closePrintView,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PrintOrder);
